import React from 'react';
import PropTypes from 'prop-types';
import { CompanyAdminSettingsFormView } from './company-settings-form-view';

export const CompanyAdminSettingsForm = ({ change, formValues, companyAdminSettingInfo }) => {
	return (
		<CompanyAdminSettingsFormView
			change={change}
			formValues={formValues}
			companyAdminSettingInfo={companyAdminSettingInfo}
		/>
	);
};

CompanyAdminSettingsForm.propTypes = {
	change: PropTypes.func.isRequired,
	formValues: PropTypes.object,
	initialValues: PropTypes.array,
	companyAdminSettingInfo: PropTypes.object,
};
